import { APPROVAL_STATUS, AUDIT_ELEMENT_TYPE, } from '@fortem-monorepo/constants';
export const ELEMENT_TYPES = {
    INSTRUMENT: AUDIT_ELEMENT_TYPE.Instrument,
    OLD_INSTRUMENT: AUDIT_ELEMENT_TYPE.OldInstrument,
    TRADE: AUDIT_ELEMENT_TYPE.Trade,
    OLD_TRADE: AUDIT_ELEMENT_TYPE.OldTrade,
    IC_GUIDELINE: AUDIT_ELEMENT_TYPE.IcGuideline,
};
export const STATUSES = {
    APPROVED: APPROVAL_STATUS.Approved,
    DRAFT: APPROVAL_STATUS.Draft,
    PENDING: APPROVAL_STATUS.Pending,
};
